// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Основные стили для Standalone GIS Widget */

.gis-widget {
  display: flex;
  width: 100%;
  height: 100%;
  font-family: Arial, sans-serif;
  flex-direction: row-reverse; /* Меняем порядок: sidebar справа */
}

.gis-widget__sidebar {
  width: 300px;
  min-width: 250px;
  max-width: 400px;
  background: #f5f5f5;
  border-left: 1px solid #ddd; /* Граница слева вместо справа */
  overflow-y: auto;
  padding: 15px;
  box-sizing: border-box;
}

.gis-widget__map-container {
  flex: 1;
  position: relative;
  height: 100%;
}

.gis-map {
  width: 100%;
  height: 100%;
}

/* Всплывающее окно информации о пункте выдачи */
.ol-popup {
  position: relative;
  z-index: 1000;
  min-width: 200px;
  max-width: 320px;
  padding: 12px 15px;
  background: white;
  border-radius: 4px;
  box-shadow: 0 2px 10px rgba(0, 0, 0, 0.2);
  font-size: 14px;
  line-height: 1.5;
  color: #333;
}

.ol-popup::after {
  content: '';
  position: absolute;
  top: 100%;
  left: 50%;
  margin-left: -8px;
  border: 8px solid transparent;
  border-top-color: white;
}

.ol-popup div {
  margin-bottom: 8px;
}

.ol-popup div:last-child {
  margin-bottom: 0;
}

.ol-popup strong {
  display: block;
  font-size: 12px;
  color: #555;
  margin-bottom: 2px;
}

.ol-popup-error {
  color: #dc3545;
}

/* Панель фильтров */
.filter-panel {
  margin-bottom: 20px;
}

.filter-panel h3 {
  margin-top: 0;
  margin-bottom: 15px;
  font-size: 16px;
  color: #333;
}

.filter-item {
  margin-bottom: 15px;
}

.filter-item label {
  display: block;
  margin-bottom: 5px;
  font-size: 14px;
  color: #555;
  font-weight: 500;
}

.filter-item select {
  width: 100%;
  padding: 8px;
  border: 1px solid #ccc;
  border-radius: 4px;
  font-size: 14px;
  background: white;
  box-sizing: border-box;
}

.filter-item select:disabled {
  background: #f0f0f0;
  color: #999;
  cursor: not-allowed;
}

.filter-controls {
  display: flex;
  align-items: flex-end;
  gap: 0;
}

.filter-controls select {
  flex: 1;
  margin-top: 5px;
}

.filter-buttons {
  display: flex;
  gap: 0;
  align-items: flex-end;
}

.filter-button {
  width: calc(1em + 18px);
  height: calc(8px + 1.2em + 8px + 2px);
  min-width: calc(1em + 18px);
  min-height: calc(8px + 1.2em + 8px + 2px);
  padding: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  border: 1px solid #ccc;
  border-radius: 0;
  background-color: #fff;
  cursor: pointer;
  font-size: 14px;
  box-sizing: border-box;
}

.filter-button:first-child {
  border-top-left-radius: 4px;
  border-bottom-left-radius: 4px;
}

.filter-button:last-child {
  border-top-right-radius: 4px;
  border-bottom-right-radius: 4px;
}

.filter-button:hover:not(:disabled) {
  background-color: #f0f0f0;
}

.filter-button:disabled {
  opacity: 0.5;
  cursor: not-allowed;
  background-color: #f5f5f5;
}

/* Панель информации */
.info-panel {
  margin-top: 20px;
}

.info-panel h3 {
  margin-top: 0;
  margin-bottom: 15px;
  font-size: 16px;
  color: #333;
}

.info-item {
  margin-bottom: 15px;
  padding-bottom: 15px;
  border-bottom: 1px solid #e0e0e0;
}

.info-item:last-child {
  border-bottom: none;
}

.info-item strong {
  display: block;
  margin-bottom: 5px;
  font-size: 14px;
  color: #555;
}

.info-item span,
.info-item p {
  font-size: 14px;
  color: #333;
  line-height: 1.5;
}

.info-item ul {
  margin: 5px 0 0 0;
  padding-left: 20px;
}

.info-item li {
  margin-bottom: 5px;
  font-size: 14px;
  color: #333;
}

.info-actions {
  margin-top: 15px;
  display: flex;
  flex-direction: column;
  gap: 10px;
}

.btn-download {
  padding: 10px 15px;
  background: #007bff;
  color: white;
  border: none;
  border-radius: 4px;
  font-size: 14px;
  cursor: pointer;
  transition: background 0.2s;
}

.btn-download:hover {
  background: #0056b3;
}

.btn-download:active {
  background: #004085;
}

.error {
  color: #dc3545;
  font-size: 14px;
}

/* Управление слоями */
.layer-control {
  position: absolute;
  top: 10px;
  right: 10px;
  background: white;
  padding: 15px;
  border-radius: 4px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.15);
  z-index: 1000;
  min-width: 200px;
}

.layer-control h4 {
  margin: 0 0 10px 0;
  font-size: 14px;
  color: #333;
}

.layer-list {
  display: flex;
  flex-direction: column;
  gap: 8px;
}

.layer-item {
  display: flex;
  align-items: center;
}

.layer-item label {
  display: flex;
  align-items: center;
  gap: 8px;
  font-size: 14px;
  color: #333;
  cursor: pointer;
}

.layer-item input[type="checkbox"] {
  cursor: pointer;
}

.layer-item .loading {
  font-size: 12px;
  color: #999;
  font-style: italic;
}

/* Адаптивность */
@media (max-width: 768px) {
  .gis-widget {
    flex-direction: column-reverse; /* На мобильных sidebar внизу */
  }

  .gis-widget__sidebar {
    width: 100%;
    max-width: 100%;
    max-height: 300px;
    border-left: none;
    border-top: 1px solid #ddd;
  }

  .layer-control {
    position: relative;
    top: auto;
    right: auto;
    margin: 10px;
  }
}


`, "",{"version":3,"sources":["webpack://./src/styles/main.css"],"names":[],"mappings":"AAAA,6CAA6C;;AAE7C;EACE,aAAa;EACb,WAAW;EACX,YAAY;EACZ,8BAA8B;EAC9B,2BAA2B,EAAE,mCAAmC;AAClE;;AAEA;EACE,YAAY;EACZ,gBAAgB;EAChB,gBAAgB;EAChB,mBAAmB;EACnB,2BAA2B,EAAE,gCAAgC;EAC7D,gBAAgB;EAChB,aAAa;EACb,sBAAsB;AACxB;;AAEA;EACE,OAAO;EACP,kBAAkB;EAClB,YAAY;AACd;;AAEA;EACE,WAAW;EACX,YAAY;AACd;;AAEA,gDAAgD;AAChD;EACE,kBAAkB;EAClB,aAAa;EACb,gBAAgB;EAChB,gBAAgB;EAChB,kBAAkB;EAClB,iBAAiB;EACjB,kBAAkB;EAClB,yCAAyC;EACzC,eAAe;EACf,gBAAgB;EAChB,WAAW;AACb;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,SAAS;EACT,SAAS;EACT,iBAAiB;EACjB,6BAA6B;EAC7B,uBAAuB;AACzB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,cAAc;EACd,eAAe;EACf,WAAW;EACX,kBAAkB;AACpB;;AAEA;EACE,cAAc;AAChB;;AAEA,oBAAoB;AACpB;EACE,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,eAAe;EACf,WAAW;AACb;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,kBAAkB;EAClB,eAAe;EACf,WAAW;EACX,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,sBAAsB;EACtB,kBAAkB;EAClB,eAAe;EACf,iBAAiB;EACjB,sBAAsB;AACxB;;AAEA;EACE,mBAAmB;EACnB,WAAW;EACX,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,qBAAqB;EACrB,MAAM;AACR;;AAEA;EACE,OAAO;EACP,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,MAAM;EACN,qBAAqB;AACvB;;AAEA;EACE,uBAAuB;EACvB,qCAAqC;EACrC,2BAA2B;EAC3B,yCAAyC;EACzC,UAAU;EACV,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,sBAAsB;EACtB,gBAAgB;EAChB,sBAAsB;EACtB,eAAe;EACf,eAAe;EACf,sBAAsB;AACxB;;AAEA;EACE,2BAA2B;EAC3B,8BAA8B;AAChC;;AAEA;EACE,4BAA4B;EAC5B,+BAA+B;AACjC;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,YAAY;EACZ,mBAAmB;EACnB,yBAAyB;AAC3B;;AAEA,sBAAsB;AACtB;EACE,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,eAAe;EACf,WAAW;AACb;;AAEA;EACE,mBAAmB;EACnB,oBAAoB;EACpB,gCAAgC;AAClC;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,kBAAkB;EAClB,eAAe;EACf,WAAW;AACb;;AAEA;;EAEE,eAAe;EACf,WAAW;EACX,gBAAgB;AAClB;;AAEA;EACE,iBAAiB;EACjB,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;EAClB,eAAe;EACf,WAAW;AACb;;AAEA;EACE,gBAAgB;EAChB,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;;AAEA;EACE,kBAAkB;EAClB,mBAAmB;EACnB,YAAY;EACZ,YAAY;EACZ,kBAAkB;EAClB,eAAe;EACf,eAAe;EACf,2BAA2B;AAC7B;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,eAAe;AACjB;;AAEA,sBAAsB;AACtB;EACE,kBAAkB;EAClB,SAAS;EACT,WAAW;EACX,iBAAiB;EACjB,aAAa;EACb,kBAAkB;EAClB,yCAAyC;EACzC,aAAa;EACb,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,eAAe;EACf,WAAW;AACb;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;AACV;;AAEA;EACE,aAAa;EACb,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,eAAe;EACf,WAAW;EACX,eAAe;AACjB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,eAAe;EACf,WAAW;EACX,kBAAkB;AACpB;;AAEA,iBAAiB;AACjB;EACE;IACE,8BAA8B,EAAE,+BAA+B;EACjE;;EAEA;IACE,WAAW;IACX,eAAe;IACf,iBAAiB;IACjB,iBAAiB;IACjB,0BAA0B;EAC5B;;EAEA;IACE,kBAAkB;IAClB,SAAS;IACT,WAAW;IACX,YAAY;EACd;AACF","sourcesContent":["/* Основные стили для Standalone GIS Widget */\r\n\r\n.gis-widget {\r\n  display: flex;\r\n  width: 100%;\r\n  height: 100%;\r\n  font-family: Arial, sans-serif;\r\n  flex-direction: row-reverse; /* Меняем порядок: sidebar справа */\r\n}\r\n\r\n.gis-widget__sidebar {\r\n  width: 300px;\r\n  min-width: 250px;\r\n  max-width: 400px;\r\n  background: #f5f5f5;\r\n  border-left: 1px solid #ddd; /* Граница слева вместо справа */\r\n  overflow-y: auto;\r\n  padding: 15px;\r\n  box-sizing: border-box;\r\n}\r\n\r\n.gis-widget__map-container {\r\n  flex: 1;\r\n  position: relative;\r\n  height: 100%;\r\n}\r\n\r\n.gis-map {\r\n  width: 100%;\r\n  height: 100%;\r\n}\r\n\r\n/* Всплывающее окно информации о пункте выдачи */\r\n.ol-popup {\r\n  position: relative;\r\n  z-index: 1000;\r\n  min-width: 200px;\r\n  max-width: 320px;\r\n  padding: 12px 15px;\r\n  background: white;\r\n  border-radius: 4px;\r\n  box-shadow: 0 2px 10px rgba(0, 0, 0, 0.2);\r\n  font-size: 14px;\r\n  line-height: 1.5;\r\n  color: #333;\r\n}\r\n\r\n.ol-popup::after {\r\n  content: '';\r\n  position: absolute;\r\n  top: 100%;\r\n  left: 50%;\r\n  margin-left: -8px;\r\n  border: 8px solid transparent;\r\n  border-top-color: white;\r\n}\r\n\r\n.ol-popup div {\r\n  margin-bottom: 8px;\r\n}\r\n\r\n.ol-popup div:last-child {\r\n  margin-bottom: 0;\r\n}\r\n\r\n.ol-popup strong {\r\n  display: block;\r\n  font-size: 12px;\r\n  color: #555;\r\n  margin-bottom: 2px;\r\n}\r\n\r\n.ol-popup-error {\r\n  color: #dc3545;\r\n}\r\n\r\n/* Панель фильтров */\r\n.filter-panel {\r\n  margin-bottom: 20px;\r\n}\r\n\r\n.filter-panel h3 {\r\n  margin-top: 0;\r\n  margin-bottom: 15px;\r\n  font-size: 16px;\r\n  color: #333;\r\n}\r\n\r\n.filter-item {\r\n  margin-bottom: 15px;\r\n}\r\n\r\n.filter-item label {\r\n  display: block;\r\n  margin-bottom: 5px;\r\n  font-size: 14px;\r\n  color: #555;\r\n  font-weight: 500;\r\n}\r\n\r\n.filter-item select {\r\n  width: 100%;\r\n  padding: 8px;\r\n  border: 1px solid #ccc;\r\n  border-radius: 4px;\r\n  font-size: 14px;\r\n  background: white;\r\n  box-sizing: border-box;\r\n}\r\n\r\n.filter-item select:disabled {\r\n  background: #f0f0f0;\r\n  color: #999;\r\n  cursor: not-allowed;\r\n}\r\n\r\n.filter-controls {\r\n  display: flex;\r\n  align-items: flex-end;\r\n  gap: 0;\r\n}\r\n\r\n.filter-controls select {\r\n  flex: 1;\r\n  margin-top: 5px;\r\n}\r\n\r\n.filter-buttons {\r\n  display: flex;\r\n  gap: 0;\r\n  align-items: flex-end;\r\n}\r\n\r\n.filter-button {\r\n  width: calc(1em + 18px);\r\n  height: calc(8px + 1.2em + 8px + 2px);\r\n  min-width: calc(1em + 18px);\r\n  min-height: calc(8px + 1.2em + 8px + 2px);\r\n  padding: 0;\r\n  display: flex;\r\n  align-items: center;\r\n  justify-content: center;\r\n  border: 1px solid #ccc;\r\n  border-radius: 0;\r\n  background-color: #fff;\r\n  cursor: pointer;\r\n  font-size: 14px;\r\n  box-sizing: border-box;\r\n}\r\n\r\n.filter-button:first-child {\r\n  border-top-left-radius: 4px;\r\n  border-bottom-left-radius: 4px;\r\n}\r\n\r\n.filter-button:last-child {\r\n  border-top-right-radius: 4px;\r\n  border-bottom-right-radius: 4px;\r\n}\r\n\r\n.filter-button:hover:not(:disabled) {\r\n  background-color: #f0f0f0;\r\n}\r\n\r\n.filter-button:disabled {\r\n  opacity: 0.5;\r\n  cursor: not-allowed;\r\n  background-color: #f5f5f5;\r\n}\r\n\r\n/* Панель информации */\r\n.info-panel {\r\n  margin-top: 20px;\r\n}\r\n\r\n.info-panel h3 {\r\n  margin-top: 0;\r\n  margin-bottom: 15px;\r\n  font-size: 16px;\r\n  color: #333;\r\n}\r\n\r\n.info-item {\r\n  margin-bottom: 15px;\r\n  padding-bottom: 15px;\r\n  border-bottom: 1px solid #e0e0e0;\r\n}\r\n\r\n.info-item:last-child {\r\n  border-bottom: none;\r\n}\r\n\r\n.info-item strong {\r\n  display: block;\r\n  margin-bottom: 5px;\r\n  font-size: 14px;\r\n  color: #555;\r\n}\r\n\r\n.info-item span,\r\n.info-item p {\r\n  font-size: 14px;\r\n  color: #333;\r\n  line-height: 1.5;\r\n}\r\n\r\n.info-item ul {\r\n  margin: 5px 0 0 0;\r\n  padding-left: 20px;\r\n}\r\n\r\n.info-item li {\r\n  margin-bottom: 5px;\r\n  font-size: 14px;\r\n  color: #333;\r\n}\r\n\r\n.info-actions {\r\n  margin-top: 15px;\r\n  display: flex;\r\n  flex-direction: column;\r\n  gap: 10px;\r\n}\r\n\r\n.btn-download {\r\n  padding: 10px 15px;\r\n  background: #007bff;\r\n  color: white;\r\n  border: none;\r\n  border-radius: 4px;\r\n  font-size: 14px;\r\n  cursor: pointer;\r\n  transition: background 0.2s;\r\n}\r\n\r\n.btn-download:hover {\r\n  background: #0056b3;\r\n}\r\n\r\n.btn-download:active {\r\n  background: #004085;\r\n}\r\n\r\n.error {\r\n  color: #dc3545;\r\n  font-size: 14px;\r\n}\r\n\r\n/* Управление слоями */\r\n.layer-control {\r\n  position: absolute;\r\n  top: 10px;\r\n  right: 10px;\r\n  background: white;\r\n  padding: 15px;\r\n  border-radius: 4px;\r\n  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.15);\r\n  z-index: 1000;\r\n  min-width: 200px;\r\n}\r\n\r\n.layer-control h4 {\r\n  margin: 0 0 10px 0;\r\n  font-size: 14px;\r\n  color: #333;\r\n}\r\n\r\n.layer-list {\r\n  display: flex;\r\n  flex-direction: column;\r\n  gap: 8px;\r\n}\r\n\r\n.layer-item {\r\n  display: flex;\r\n  align-items: center;\r\n}\r\n\r\n.layer-item label {\r\n  display: flex;\r\n  align-items: center;\r\n  gap: 8px;\r\n  font-size: 14px;\r\n  color: #333;\r\n  cursor: pointer;\r\n}\r\n\r\n.layer-item input[type=\"checkbox\"] {\r\n  cursor: pointer;\r\n}\r\n\r\n.layer-item .loading {\r\n  font-size: 12px;\r\n  color: #999;\r\n  font-style: italic;\r\n}\r\n\r\n/* Адаптивность */\r\n@media (max-width: 768px) {\r\n  .gis-widget {\r\n    flex-direction: column-reverse; /* На мобильных sidebar внизу */\r\n  }\r\n\r\n  .gis-widget__sidebar {\r\n    width: 100%;\r\n    max-width: 100%;\r\n    max-height: 300px;\r\n    border-left: none;\r\n    border-top: 1px solid #ddd;\r\n  }\r\n\r\n  .layer-control {\r\n    position: relative;\r\n    top: auto;\r\n    right: auto;\r\n    margin: 10px;\r\n  }\r\n}\r\n\r\n\r\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
